export class CCommonPage {
    fId: string;
    fDateLastUpdate: string;
    fDateLastUpdatePersian: string;
    fUserIdEditor: string;
    fMetaTitle: string;
    fMetaDescription: string;
    fMetaKeywords: string;
    fPageContents: string;
    fPageSlogan: string;
    fImageSlideShow1: string;
    fImageSlideShow2: string;
    fImageSlideShow3: string;

    constructor() {
        this.fId = "";
        this.fDateLastUpdate = "";
        this.fDateLastUpdatePersian = "";
        this.fUserIdEditor = "";
        this.fMetaTitle = "";
        this.fMetaDescription = "";
        this.fMetaKeywords = "";
        this.fPageContents = "";
        this.fPageSlogan = "";
        this.fImageSlideShow1 = "";
        this.fImageSlideShow2 = "";
        this.fImageSlideShow3 = "";
    }
}